import { IChildProp } from '@intelligence/components/Form/type';

const FOLLOWING_CURRENT_MOBILE_GAME: IChildProp[] = [
  {
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'textGroup',
    children: [{
      isDefault: true,
      enumKey: 'activeUsers_appannie',
    }, {
      isDefault: true,
      enumKey: 'revenue_appannie',
    }, {
      isDefault: true,
      enumKey: 'downloads_appannie',
    }, {
      isDefault: true,
      enumKey: 'activeUsers_sensorTower',
    }, {
      isDefault: true,
      enumKey: 'revenue_sensorTower',
    }, {
      isDefault: true,
      enumKey: 'downloads_sensorTower',
    }, {
      enumKey: 'd2_mobile',
      enumTargetType: 'metric',
    }, {
      enumKey: 'd3_mobile',
      enumTargetType: 'metric',
    }, {
      enumKey: 'd7_mobile',
      enumTargetType: 'metric',
    }, {
      enumKey: 'd15_mobile',
      enumTargetType: 'metric',
    }, {
      enumKey: 'd31_mobile',
      enumTargetType: 'metric',
    }, {
      isDefault: true,
      enumKey: 'hoursWatched',
    }, {
      isDefault: true,
      enumKey: 'peakCCV',
    }],
  }, {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }],
  }, {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      label: 'Time Settings',
      labelKey: 'dbi_label_time_settings',
      enumKey: 'dateSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
        msgKey: 'dbi_info_mobile_time_settings_info',
      }]
    }, {
      enumKey: 'timeSettingsByTime',
      enumTargetType: 'downloadMainCategory',
      condition: 'dateSettings:byTime',
      type: 'checkboxGroup',
      children: [{
        enumKey: 'daily',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:daily',
      }, {
        enumKey: 'weekly',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:weekly',
      }, {
        enumKey: 'monthly',
        enumTargetType: 'granularity',
        defaultSelectCondition: 'additionalFields:dateType:monthly',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }
];

const FOLLOWING_OTHER: IChildProp[] = [
  {
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'textGroup',
    condition: '!additionalFields:entityType:company',
    children: [{
      isDefault: true,
      enumKey: 'pcu',
      enumTargetType: 'metric',
      condition: 'additionalFields:entityType:pc',
    }, {
      isDefault: true,
      enumKey: 'steamData_SteamFollowers',
      enumTargetType: 'metric',
      condition: 'additionalFields:entityType:pc',
    }, {
      isDefault: true,
      enumKey: 'steamData_SteamReviews',
      enumTargetType: 'metric',
      condition: 'additionalFields:entityType:pc',
    }, {
      isDefault: true,
      enumKey: 'digitalRevenue',
      enumTargetType: 'metric',
    }, {
      isDefault: true,
      enumKey: 'hoursWatchedHour',
      enumTargetType: 'metric',
    }, {
      isDefault: true,
      enumKey: 'peakCCV',
      enumTargetType: 'metric',
    }],
  }, {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      label: 'Time Settings',
      labelKey: 'dbi_label_time_settings',
      value: 'special_timeSettings',
      type: 'radio',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        isDefault: true,
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }
];

export default {
  followingCurrentMobile: FOLLOWING_CURRENT_MOBILE_GAME,
  followingCurrentPC: FOLLOWING_OTHER,
};
